import React from 'react';
import './index.less';

export const teamSelectSkeletonShape = <div className="teamSelectSkeletonShape" />;
export const advancedFiltersSkeletonShape = <div className="advancedFiltersSkeletonShape" />;
export const searchBarSkeletonShape = <div className="searchBarSkeletonShape" />;
